import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { IMAGES_PATH } from "../../../../constants";
import {
  ThumbnailBox,
  ThumbnailImg,
  ThumbnailPlaceholder,
  PlayRecordingButton,
  DetailRow,
  DetailText,
  DetailsStack,
  DownloadButtonsStack,
} from "./RecordingCard.styles";
import { PrimaryButton } from "../../../../components/form";
import FlexBox from "../../../../components/layouts/Flexbox";
import { Buildings, CalendarDots, Clock, UserCircle } from '@phosphor-icons/react';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';

interface RecordingDetailsProps {
  thumbnailUrl: string;
  isThumbnailLoaded: boolean;
  onThumbnailLoad: () => void;
  onPlayRecording: () => void;
  attendeeLabel?: string;
  company?: string;
  dateFormatted: string;
  timeFormatted: string;
  recordingDownloadUrl: string;
  transcriptDownloadUrl: string;
  onDownloadFile: (url: string, label: string) => void;
}

export default function RecordingDetails({
  thumbnailUrl,
  isThumbnailLoaded,
  onThumbnailLoad,
  onPlayRecording,
  attendeeLabel,
  company,
  dateFormatted,
  timeFormatted,
  recordingDownloadUrl,
  transcriptDownloadUrl,
  onDownloadFile,
}: RecordingDetailsProps) {
  return (
    <FlexBox gap={2} flexDirection={{ xs: "column", sm: "row" }}>
      <ThumbnailBox>
        {!isThumbnailLoaded && (
          <ThumbnailPlaceholder
            src={`${IMAGES_PATH}/zoom default.png`}
            alt="Thumbnail"
          />
        )}
        <ThumbnailImg
          src={thumbnailUrl}
          alt="Thumbnail"
          onLoad={onThumbnailLoad}
          $loaded={isThumbnailLoaded}
        />
        <PlayRecordingButton
          onClick={(e) => {
            e.stopPropagation();
            onPlayRecording();
          }}
          startIcon={<PlayArrowIcon />}
        >
          Play Recording
        </PlayRecordingButton>
      </ThumbnailBox>
      <DetailsStack>
        {attendeeLabel && (
          <DetailRow>
            <AccountCircleTwoToneIcon fontSize="medium" />
            <DetailText title={attendeeLabel}>{attendeeLabel}</DetailText>
          </DetailRow>
        )}
        {company && (
          <DetailRow>
            <Buildings size={22} weight="duotone" />
            <DetailText>{company}</DetailText>
          </DetailRow>
        )}
        <DetailRow>
          <CalendarDots size={22} weight="duotone" />
          <DetailText>{dateFormatted}</DetailText>
        </DetailRow>
        <DetailRow>
          <Clock size={22} weight="duotone" />
          <DetailText>{timeFormatted}</DetailText>
        </DetailRow>
        <DownloadButtonsStack>
          <PrimaryButton
            onClick={(e) => {
              e.stopPropagation();
              onDownloadFile(recordingDownloadUrl, "Recording");
            }}
            startIcon={<FileDownloadOutlinedIcon />}
          >
            Recording
          </PrimaryButton>
          <PrimaryButton
            onClick={(e) => {
              e.stopPropagation();
              onDownloadFile(transcriptDownloadUrl, "Transcript");
            }}
            startIcon={<FileDownloadOutlinedIcon />}
          >
            Transcript
          </PrimaryButton>
        </DownloadButtonsStack>
      </DetailsStack>
    </FlexBox>
  );
}
